import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as RT from '../../constants/Routing';

class Auth extends Component {

  constructor(props) {
    super(props);
    // console.log(props);
    // console.log(this.props);
    this.state = {
      isAuthenticated: !!localStorage.getItem('token') && this.props.currentUser
    };
  }

  componentWillMount() {
    this.userWillTransfer(this.props);
  }

  componentWillUpdate(nextProps) {
    this.userWillTransfer(this.props);
  }

  userWillTransfer(props) {
    if (!localStorage.getItem('token') || !this.props.currentUser) {
      if (this.state.isAuthenticated !== false) {
        this.setState({
          isAuthenticated: false
        });
      }
    } else {
      if (this.state.isAuthenticated !== true) {
        this.setState({
          isAuthenticated: true
        });
      }
    }
  }

  render() {
      // // ユーザー情報を入力していないときのリダイレクト処理
      // if (!!localStorage.getItem('token') && !!currentUser) {
      //   if (!this.propscurrentUser.registered_at && currentPath !== RT.USER_FIRST_PROF_PATH) {
      //     console.log('ユーザー情報入ってないやんけ！！', this)
      //     return ( <
      //       Redirect to = {
      //         RT.USER_FIRST_PROF_PATH
      //       }
      //       />
      //     )
      //   }
      // }
    
    if (this.state.isAuthenticated) {
      if (!!this.props.currentUser && !this.props.currentUser.registered_at && this.props.currentPath !== RT.USER_FIRST_PROF_PATH) {
        return (
          <Redirect to={RT.USER_FIRST_PROF_PATH} />
        )
      } else {
        return (
          <Route children={this.props.children} />
        )
      }
    } else {
      return (
        <Redirect to={RT.SIGN_IN_PATH} />
      )
    }
    // return (
    //   this.state.isAuthenticated? (
    //   ):(
    //     <Redirect to={RT.SIGN_IN_PATH} />
    //   )
    // )
  }
}

const mapStateToProps = state => {
  return state
};

export default withRouter(connect(mapStateToProps)(Auth));


// WEBPACK FOOTER //
// ./src/components/App/Auth.js